import { useContext } from 'react';
import { PermissionsContext } from '@/contexts/PermissionsContext';

/**
 * Hook público de acesso ao RBAC granular. Uso:
 *   const { can, isOwner, moduleEnabled } = usePermissions();
 *   if (can('courts.manage')) { ... }
 */
export function usePermissions() {
  const ctx = useContext(PermissionsContext);
  if (!ctx) throw new Error('usePermissions must be used within PermissionsProvider');
  return ctx;
}
